import React from "react";

export const oakTreeReferralsConfig = [
  {
    auth: ["user"],
    routes: [
      {
        path: "/oaktree-referral",
        component: React.lazy(() => import("./AppReferralsList")),
      },
    ],
  },
  {
    auth: ["user"],
    routes: [
      {
        path: "/view-referral",
        component: React.lazy(() => import("./ViewReferrals")),
      },
    ],
  },
];